<template>
  <div class="wrapperddiv">
    <el-card class="box-card" >
		<el-row type="flex" justify="end">
			<el-button-group>
		<el-button type="danger" @click="delSelectDialogVisible=true">区间批量删除</el-button>
		</el-button-group>
		<el-button type="primary"  @click="addBtnFn">添加国家</el-button>
		<el-upload
		    class="upload-demo"
		    action=""
		    :on-change="handleChange"
		    :show-file-list="false"
		    :auto-upload="false">
		    <el-button  type="primary" >导入excel文件</el-button>
		  </el-upload>
		  	<el-button type="primary" @click="exportTableData">导出表格数据</el-button>
		<el-button-group>
		</el-button-group>
		</el-row>
			<el-divider></el-divider>
		<el-row :gutter="20" style="padding: 30px 0 30px 0;">
		<el-col :span="8">
		<el-input placeholder="请输入内容"
		v-model="queryInfo.query" 
		clearable 
		@input="changeValue"
		>
		<el-button slot="append" icon="el-icon-search" @click="initListFn"></el-button>
		</el-input>
		</el-col>

		
		<el-col :span="2" :offset="6">
			<el-button type="text" style="color: black;">筛选时间:</el-button>
		</el-col>
		<el-col :span="8">
		<el-date-picker
		  v-model="queryInfo.Sxvalue"
		  type="datetimerange"
		  :picker-options="pickerOptions"
		  range-separator="至"
		  start-placeholder="开始日期"
		  end-placeholder="结束日期"
		  align="right"
		  unlink-panels
		 :clearable="false"
		  >
		</el-date-picker>
		</el-col>
		</el-row>
      <div slot="header" class="clearfix header-box">
        <span>国际快递国家</span>
      </div>
      <!-- 表格区域 -->
      <el-table
		v-loading="loading"
		element-loading-text="拼命加载中"
		    element-loading-spinner="el-icon-loading"
		    element-loading-background="rgba(0, 0, 0, 0.8)"
	  style="width: 100%" 
	  :data="dataList" 
	  border 
	  stripe 
	  ref="tableDataRef"
	  row-key="id"
	  @selection-change="handleSelectionChange">
	  <el-table-column
	    type="selection"
	  	  :reserve-selection="true"
	        width="55">
	      </el-table-column>
        <el-table-column
          label="序号"
          type="index"
        >
		</el-table-column>
		<el-table-column
		      label="ID"
		     prop="id"
		    >
		</el-table-column>
		<el-table-column label="分区代码" prop="part_code"></el-table-column>
        <el-table-column label="分区" prop="part"></el-table-column>
        <el-table-column label="country_code" prop="country_code"></el-table-column>
		<el-table-column label="国家信息" prop="country_zh"></el-table-column>
		<el-table-column label="全称" prop="country_en"></el-table-column>
			<el-table-column label="更新日期" prop="time"  width="150px">
				<template slot-scope="scope">
					 {{scope.row.time | fmtdate}}
				</template>
			</el-table-column>	
        <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="updateFn(scope.row)">修改</el-button>
                <el-button type="danger" size="mini" @click="removeFn(scope.row.id)">删除</el-button>
            </template>
        </el-table-column>
      </el-table>
	  <!-- 分页区域 -->
	  			<el-pagination 
	  			@size-change="handleSizeChange" 
	  			@current-change="handleCurrentChange"
	  			:current-page="queryInfo.pagenum" 
	  			:page-sizes="[10, 50, 100, 200]" 
	  			:page-size="queryInfo.pagesize"
	  			layout="total, sizes, prev, pager, next, jumper" :total="total">
	  			</el-pagination>
    </el-card>

    <!-- 添加对话框 -->
    <el-dialog 
	title="添加国家" 
	:visible.sync="addVisible" 
	width="55%" 
	@closed="onAddClosedFn">
      <el-form
        :model="addForm"
        :rules="addRules"
        ref="addRef"
        label-width="110px"
      >
	  <el-form-item label="分区代码" prop="part_code">
	    <el-input
	      v-model="addForm.part_code"
	    ></el-input>
	  </el-form-item>
        <el-form-item label="分区" prop="part">
          <el-input
            v-model="addForm.part"
          ></el-input>
        </el-form-item>
     <el-form-item label="country_code" prop="country_code">
       <el-input
         v-model="addForm.country_code"
       ></el-input>
     </el-form-item>
		 <el-form-item label="国家信息" prop="country_zh">
		   <el-input
		     v-model="addForm.country_zh"
		   ></el-input>
		 </el-form-item>
		 <el-form-item label="全称" prop="country_en">
		   <el-input
		     v-model="addForm.country_en"
		   ></el-input>
		 </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelFn">取 消</el-button>
        <el-button size="mini" type="primary" @click="addFn">添 加</el-button>
      </span>
    </el-dialog>
	<!-- 编辑的对话框 -->
	<el-dialog 
	title="编辑国家" 
	:visible.sync="editVisible" 
	width="55%" 
	@closed="onEditClosedFn">
	  <el-form
	    :model="editForm"
	    :rules="editRules"
	    ref="editRef"
	    label-width="110px"
	  >
	  <el-form-item label="分区代码" prop="part_code">
	    <el-input
	      v-model="editForm.part_code"
	    ></el-input>
	  </el-form-item>
	    <el-form-item label="分区" prop="part">
	         <el-input
	           v-model="editForm.part"
	         ></el-input>
	       </el-form-item>
	    <el-form-item label="country_code" prop="country_code">
	      <el-input
	        v-model="editForm.country_code"
	      ></el-input>
	    </el-form-item>
	    		 <el-form-item label="国家信息" prop="country_zh">
	    		   <el-input
	    		     v-model="editForm.country_zh"
	    		   ></el-input>
	    		 </el-form-item>
	    		 <el-form-item label="全称" prop="country_en">
	    		   <el-input
	    		     v-model="editForm.country_en"
	    		   ></el-input>
	    		 </el-form-item>
	  </el-form>
	  <span slot="footer" class="dialog-footer">
	    <el-button size="mini" @click="editcancelFn">取 消</el-button>
	    <el-button size="mini" type="primary" @click="editFn">确 定</el-button>
	  </span>
	</el-dialog>
	
	<el-dialog
	:lock-scroll="false" 
	title="区间批量删除" 
	:visible.sync="delSelectDialogVisible" 
	width="50%"
	@close="delSelectDialogClosed" 
	:close-on-click-modal="false">
		<el-form 
		ref="delSelectFormRef" 
		:model="delSelectForm" 
		label-width="100px">
		<el-row :gutter="20">
			<el-col :span="2">
				<el-button type="text" style="color: black;">选择ID区间:</el-button>
			</el-col>
			<el-col :span="9">
				<el-form-item  prop="start">
					<el-input v-model="delSelectForm.start"  type="number"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="1">
				<el-button type="text" style="color: black;">到</el-button>
			</el-col>
			<el-col :span="9"  style="margin-left: -95px;">
				<el-form-item  prop="end">
					<el-input v-model="delSelectForm.end" type="number" ></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		</el-form>
		<span slot="footer" class="dialog-footer">
				<el-button @click="delSelectDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="delSelectConfirm">确 定</el-button>
			</span>
		</el-dialog>
		
		
  </div>
</template>

<script>
//表格导入依赖
import XLSX from 'xlsx'
import moment from 'moment';
export default {
  data () {
    return {
		loading: false,
		fileContent: '',
		file: '',
		data: '',
		queryInfo: {
			query: '',
			Sxvalue:[new Date(new Date()- 3600 * 1000 * 24 * 365),new Date()],
			//当前的页数
			pagenum: 1,
			//当前每页显示多少条数据
			pagesize: 10,
		},
		total: 0,
		//日期
		pickerOptions: {
		         shortcuts: [{
		           text: '最近一周',
		           onClick(picker) {
		             const end = new Date();
		             const start = new Date();
		             start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
		             picker.$emit('pick', [start, end]);
		           }
		         }, {
		           text: '最近一个月',
		           onClick(picker) {
		             const end = new Date();
		             const start = new Date();
		             start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		             picker.$emit('pick', [start, end]);
		           }
		         }, {
		           text: '最近三个月',
		           onClick(picker) {
		             const end = new Date();
		             const start = new Date();
		             start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
		             picker.$emit('pick', [start, end]);
		           }
		         }]
		       },
	//延时器，防抖，防止用户频繁请求
	  timer:null,
      dataList: [], // 数据列表
      addVisible: false, 
	  editVisible:false,
      addForm: { 
	   part_code:'',
       part:'',
	   country_code:'',
	   country_zh:'',
	   country_en:''
      },
      addRules: { 
		  part_code:[
		  	{required:true,message:'请输入分区代码',trigger:'blur'},
		       
		  ],
       part:[
       	{required:true,message:'请输入分区',trigger:'blur'},
     
       ],
		country_code:[
			 	{required:true,message:'请输入国家代码',trigger:'blur'},

			 ],
		country_zh:[
			 	{required:true,message:'请输入国家信息',trigger:'blur'},
			
			 ],
			 country_en:[
			 	 	{required:true,message:'请输入全称',trigger:'blur'},
			 	
			 	 ],
			 
		
      },
	  editForm: {},
	  editRules: { 
		  part_code:[
		  	{required:true,message:'请输入分区代码',trigger:'blur'},
		       
		  ],
	 part:[
	 	{required:true,message:'请输入分区',trigger:'blur'},
	      
	 ],
	 		country_code:[
	 			 	{required:true,message:'请输入国家代码',trigger:'blur'},
	 
	 			 ],
	 		country_zh:[
	 			 	{required:true,message:'请输入国家信息',trigger:'blur'},
	 			
	 			 ],
	 			 country_en:[
	 			 	 	{required:true,message:'请输入全称',trigger:'blur'},
	 			 	
	 			 	 ],
	  				 
	  		
	  },
	  
	  //区间批量删除
	  delSelectDialogVisible:false,
	  delSelectForm:{
	  	start:'',
	  	end:''
	  },
	  exportList:[]
    }
  },
  
  created () {
    this.initListFn()
  },
  methods: {
	  //导出表格数据
	  	  async  exportTableData () {
				const {data:res} = await this.$http.exportExpress()
				this.exportList = res.data
	  	      // 对选择的表格数据处理：添加标题
	  	      let arr = this.exportList.map(item => {
	  	        return {
	  				   ID:item.id,
					   分区代码:item.part_code,
					   分区:item.part,
					   country_code:item.country_code,
					   国家信息:item.country_zh,
					   全称:item.country_en,
					   更新日期:item.time     
	  	        }
	  	      })
	  	      // 将json数据变为sheet数据
	  	      // json_to_sheet: 将一个由对象组成的数组转成sheet；
	  	      let sheet = XLSX.utils.json_to_sheet(arr)
	  	      // 新建表格
	  	      let book = XLSX.utils.book_new()
	  	      // 在表格中插入一个sheet
	  	      XLSX.utils.book_append_sheet(book, sheet, "sheet1")
	  	      // 通过xlsx的writeFile方法将文件写入
	  	      XLSX.writeFile(book, `国际快递国家.xls`)
	  	    },
	 
	  
	  //导入
	  			// 核心部分代码(handleChange 和 importfile)
	  			handleChange (file, fileList) {
	  			  this.fileContent = file.raw
	  			  const fileName = file.name
	  			  const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
						if(file.size / 1024 /1024 > 2){
						return	this.$message({
								type: 'warning',
								message: '该文件大小不能超过2MB,请检查ID是否异常溢出！'
							})
						}
						
	  			    if (this.fileContent) {
	  			      if (fileType === 'xlsx' || fileType === 'xls') {
	  			        this.importfile(this.fileContent)
	  			      } else {
	  			        this.$message({
	  			          type: 'warning',
	  			          message: '附件格式错误，请重新上传！'
	  			        })
	  			      }
	  			    } else {
	  			      this.$message({
	  			        type: 'warning',
	  			        message: '请上传附件！'
	  			      })
	  			    }
	  			  },
	  			 importfile (obj) {
	  			   const reader = new FileReader()
	  			   const _this = this
	  			   reader.readAsArrayBuffer(obj)
	  			   reader.onload = async function(){
	  			     const buffer = reader.result
	  			     const bytes = new Uint8Array(buffer)
	  			     const length = bytes.byteLength
	  			     let binary = ''
	  			     for (let i = 0; i < length; i++) {
	  			       binary += String.fromCharCode(bytes[i])
	  			     }
	  			      const XLSX = require('xlsx')
	  			      const wb = XLSX.read(binary, {
	  			        type: 'binary'
	  			      })
	  			      const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
	  			      this.data = [...outdata]
	  			      const arr = []
	  			      this.data.map (v => {
	  			        const obj ={}
	  			        obj.id = v.ID
						obj.part_code = v.分区代码
	  			        obj.part = v.分区
	  					obj.country_code = v.country_code
						obj.country_zh = v.国家信息
						obj.country_en = v.全称
						obj.time = v.更新日期 = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
	               arr.push(obj)
	  			      })
	  				 // //后端请求数据
	  				 // //这里不能用this，用_this
					 //数据格式化数组对象转成(),(),()
					 let str = arr.reduce((total,item,index)=>{
						 //累加三个逗号
					     if(index!=0){total+=','}
					     total+='("'+ encodeURIComponent(Object.values(item).join('","'))  +'")'
					     return total
					 },"")
					   let datainfo={
						   infoString:decodeURIComponent(str)
					   }
					 
					 const {data: res} = await _this.$http.addMoreExpress({data:datainfo})				 
					 if (res.status !== 0) {
					 	return _this.$message.error(res.message)
					 }
					   _this.$message.success('导入成功！')
					setTimeout(() => {
						window.location.reload()
					     }, 500);
					 					
					
	  			    }
	  			  },
	   
	  
	  

	  
	  changeValue(e) {
	              this.queryInfo.pagenum = 1
	  clearTimeout(this.timer)
	          this.timer = setTimeout(()=>{
	          		this.queryInfo.query = e
	          		 console.log(this.queryInfo.query)
	          		this.initListFn()
	  
	          	},500)
	         },
	  // 获取列表
	  async initListFn () {
		this.loading = true
	    const {data:res} = await this.$http.getExpress({params:this.queryInfo})
	    this.dataList = res.data
		this.total = res.total
		this.loading = false
	  },
	  //监听pagesize改变的事件
	  handleSizeChange(newSize) {
	  	this.queryInfo.pagesize = newSize
	  	this.initListFn()
	  },
	  //监听页面值改变的事件
	  handleCurrentChange(newPage) {
	  	this.queryInfo.pagenum = newPage
	  	this.initListFn()
	  },
    // 点击出对话框
    addBtnFn () {
      this.addVisible = true
    },
    //确定添加
     addFn () {
      this.$refs.addRef.validate(async valid => {
        if (valid) {
			// console.log(this.addForm)
            const { data: res } = await this.$http.AddExpress(this.addForm)
			if (res.status !== 0) {
			return this.$message.error(res.message.includes('country_code')== true ? '国家代码重复！' : (res.message.includes('country_zh')== true ? '国家信息重复' : '全称重复'))
			}
          this.$message.success('添加成功！')
          this.addVisible = false
		  //this.initListFn()
		  window.location.reload()
        } else {
          return false
        }
      })
    },
    // 对话框内点击事件
    cancelFn () {
      this.addVisible = false
    },
    // 对话框关闭事件
    onAddClosedFn () {
      this.$refs.addRef.resetFields()
    },
    async updateFn (obj) {
	  let objId = obj.id
	   const { data: res } = await this.$http.byIdExpress(objId)
	    this.editForm = res.data
		this.editVisible = true 
    },
	 editFn(){
		this.$refs.editRef.validate(async valid => {
		  if (valid) {
		      const { data: res } = await this.$http.editExpress(this.editForm)
			  if (res.status !== 0) {
			   return this.$message.error(res.message.includes('country_code')== true ? '国家代码重复！' : (res.message.includes('country_zh')== true ? '国家信息重复' : '全称重复'))
			  }
		    this.$message.success('修改成功！')
		    this.editVisible = false
			 //this.initListFn()
			 window.location.reload()
		  } else {
		    return false
		  }
		})
		
	},
	editcancelFn () {
	  this.editVisible = false
	},
	// 对话框关闭事件
	onEditClosedFn () {
	  this.$refs.editRef.resetFields()
	},
    // 删除
    async removeFn (id) {
		const confirmResult = await this.$confirm('此操作将永久删除是否继续?', '提示', {
		  confirmButtonText: '确定',
		  cancelButtonText: '取消',
		  type: 'warning',
		   lockScroll:false
		}).catch(err => err)
		if (confirmResult !== 'confirm'){
			return this.$message.info('已取消删除')
		}
		const { data: res } = await this.$http.delExpress(id)
		if (res.status!== 0) return this.$message.error('删除失败！')
		this.$message.success('删除成功！')
		// 重新请求列表数据
		this.initListFn()
		
    },
	
	//区间删除
	async delSelectConfirm(){
		if (this.delSelectForm.start == '' && this.delSelectForm.end == '') {
			return this.$message.warning('请填写ID！')
		}
		const confirmResult = await this.$confirm('注意！此操作将批量删除, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
			lockScroll:false
		}).catch(err => err)
		//如果确认删除，则返回值为字符串 confirm
		console.log(confirmResult)
		if (confirmResult !== 'confirm') {
			return this.$message.info('已取消删除')
		}
		let idString = `${this.delSelectForm.start},${this.delSelectForm.end}`
		const {
			data: res
		} = await this.$http.delBatchExpress({
			id: idString
		})
		if (res.status !== 0) {
			return this.$message.error('批量删除失败!')
		}
		this.$message.success('批量删除成功!')
		this.initListFn()
		this.delSelectDialogVisible = false
		},
		delSelectDialogClosed(){
			this.$refs.delSelectFormRef.resetFields()
		},
		
  }
}
</script>

<style lang="less" scoped>
.header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (min-width: 1280px) {
		.wrapperddiv{
			height: 100vh;
			width: 100%;
			display:inline-block;
		} 
	}
	
	//手机端
	@media screen and (max-width: 1280px) {
		.wrapperddiv{
			height: 100%;
			width: 100%;
			display:inline-block;
		} 
	}
</style>
